export function createTTLCache<K, V>(
  ttlMs: number
): {
  get(key: K): V | undefined;
  set(key: K, value: V): void;
  delete(key: K): void;
  clear(): void;
} {
  const map = new Map<K, { value: V; expiresAt: number }>();
  return {
    get(key: K): V | undefined {
      const entry = map.get(key);
      if (!entry) return undefined;
      if (Date.now() >= entry.expiresAt) return undefined;
      return entry.value;
    },
    set(key: K, value: V): void {
      map.set(key, { value, expiresAt: Date.now() + ttlMs });
    },
    delete(key: K): void {
      map.delete(key);
    },
    clear(): void {
      map.clear();
    },
  };
}
